import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isFranchisePortalSession } from "../../../utils/franchiseSession";

const FRANCHISE_HOME = "/franchise-restaurants";
const FRANCHISE_ALLOWED_PATHS = new Set([
  FRANCHISE_HOME,
  "/franchise-profile",
]);

export default function FranchiseRouteGuard({ children }) {
  const location = useLocation();
  const franchisePortal = isFranchisePortalSession();
  const pathname = location.pathname.replace(/\/+$/, "") || "/";

  if (franchisePortal && !FRANCHISE_ALLOWED_PATHS.has(pathname)) {
    return <Navigate to={FRANCHISE_HOME} replace />;
  }

  return children || <Outlet />;
}
